export default __webpack_public_path__ + "static/media/Firm.0e1068ef.pdf";